module.exports = __webpack_public_path__ + "static/media/epsFUSDT.4e6edb91.png";